import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import {
    BooleanGridColumnType,
    ActionButtons,
    ActionButtonTypes,
    buildActionButton, ArrayColumnType
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";

const ParkingZoneListView = () => {

	const navigate = useNavigate();
	const repository = new ParkingZoneRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      },
      {
        value: 'Name|asc',
        label: t('Name') + ' (A-Z)'
      },
      {
        value: 'Name|desc',
        label: t('Name') + ' (Z-A)'
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/parking-zones/" + event.Id);
    }

	const { items, totalCount, itemsOnPage, onDeleteHandler, onEditHandler, onPage, isSearching, onFilterChangedHandler , onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
        { field: 'Id', headerName: t('ID'), width: 70, sortable: false },
        { field: 'Name', headerName: t('Name'), width: 130, sortable: false  },
        { field: 'Code', headerName: t('Code'), width: 100, sortable: false  },
        { field: 'ParkomaticId', headerName: t('Parkomatic Id'), width: 130, sortable: false  },
        { field: 'ForgiveFineForLongParking', headerName: t('FF'), width: 80, sortable: false  },
        { field: 'PermitSystemIds', headerName: t('Billing Id'), width: 130, sortable: false, ...ArrayColumnType  },
        { field: 'FineSystemId', headerName: t('ParkEnforcer Id'), width: 130, sortable: false  },
         { field: 'FineAmount', headerName: t('Fine amount'), width: 100, sortable: false  },
         { field: 'ToleranceTime', headerName: t('Tolerance time'), width: 130, sortable: false  },
         { field: 'GraceTime', headerName: t('Grace time'), width: 130, sortable: false  },
         {
          field: 'IsActive',
          headerName: t('Active'),
          width: 100,
          sortable: false,
          ... BooleanGridColumnType
        },
        {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler)])
        }
    ];

	return (
	    <GridSkeleton title={t("Parking zones")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort}/>)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default ParkingZoneListView;
